import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirdrop2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAirdrop2"><Path fillRule="evenodd" clipRule="evenodd" d="M15.255 16H17V22H7V16H8.74505L3 11.486V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V11.486L15.255 16ZM17.0964 11.747C17.1993 11.755 17.3007 11.763 17.4002 11.771L13 15.2282V11.5148C14.3262 11.5509 15.8256 11.6482 17.0964 11.747ZM11 11.5148V15.2282L6.59981 11.771C6.69932 11.763 6.80066 11.755 6.90361 11.747C8.17443 11.6482 9.67378 11.5509 11 11.5148Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirdrop2;
